import React from 'react'
import { Link } from 'react-router-dom'
import styled from "@emotion/styled"
import dummy from "../../assets/top.png"
const Top = () => {
  return (
    <STopWrap>
      <STopCenter>
        <img src={dummy} alt="top"/>
        <SHeading>
          じぶんだけのアバターをつくろう！<br />
          友達やたいせつな人にアバターを送ろう！
        </SHeading>

        <SCard>
          <SCardContent>
            <SCardTitle>
              注意事項!
            </SCardTitle>
            <SCardDetail>
              ★個人のアイコンなどにご使用ください。<br/>
              ★トレースや画像の加工は禁止です。<br/>
              ★グッズ制作などへの転用も禁止です。<br/>
            </SCardDetail>
          </SCardContent>
        </SCard>

        <SButton>
          <Link to="/avatar">
            <SButtonGrad>
              アバターを作ろう
            </SButtonGrad>
          </Link>
        </SButton>
      </STopCenter>
    </STopWrap>
  )
}

const STopWrap = styled.div`
  margin: 0 auto;
  padding: 32px 16px;
  max-width: 800px;

  a {
    color: #fff;
    font-size: .75rem;
    text-decoration: none;
  }
`
const STopCenter = styled.div`
  text-align: center;
  width: 400px;
  img {
    width: 400px;
  }
`
const SHeading = styled.div`
  margin-top: 20px;
  font-family: 'M PLUS 1p', sans-serif;
`
const SCard = styled.div`
  width: 288px;
  height: auto;
  margin: 50px auto 10px;
`
const SCardContent = styled.div`
  position: relative;
  top: -16px;
  transform: scale(.9);
  box-shadow: 0px 4px 4px rgba(0,0,0,.4);
  border-top: solid 6px #333;
  width: 100%;
  height: auto;
  padding: 20px 18px;
  background: #ffffff;
  box-sizing: border-box;
  * + *{
    margin-top: 10px;
  }
`
const SCardTitle = styled.div`
  font-family: 'M PLUS 1p', sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 125%;
`
const SCardDetail = styled.div`
  font-size: 12px;
  line-height: 150%;
`

const SButton = styled.div`
  display: flex;
  justify-content: center;
`

const SButtonGrad = styled.button`
  font-weight: bold;
  background-image: linear-gradient(to right, #fc00ff 0%, #00dbde  51%, #fc00ff  100%);
  box-shadow: 2px 8px 21px -2px #777777;
  margin: 10px;
  padding: 15px 45px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  border: none;
  display: block;
  transition: all 0.3s;

  &:hover {
    transform: translateY(5px);
    background-position: right center;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
  }

`

export default Top
